document.addEventListener('DOMContentLoaded', () => {
    const tables = Array.from(document.querySelectorAll('.single-content table, .page-content table, .offer-section table'));

    if (!tables.length) {
        return;
    }

    const interactiveSelector = 'a, button, input, textarea, select, label';

    const syncScrollableState = () => {
        tables.forEach((table) => {
            const isScrollable = table.scrollWidth > table.clientWidth + 1;
            table.classList.toggle('is-scrollable-table', isScrollable);
        });
    };

    tables.forEach((table) => {
        let activePointerId = null;
        let startX = 0;
        let startY = 0;
        let startScrollLeft = 0;
        let isDragging = false;
        let shouldCancelClick = false;

        const resetDrag = () => {
            activePointerId = null;
            isDragging = false;
            table.classList.remove('is-dragging');
        };

        table.addEventListener('pointerdown', (event) => {
            if (!table.classList.contains('is-scrollable-table')) {
                return;
            }

            if (event.pointerType === 'mouse' && event.button !== 0) {
                return;
            }

            if (event.target.closest(interactiveSelector)) {
                return;
            }

            activePointerId = event.pointerId;
            startX = event.clientX;
            startY = event.clientY;
            startScrollLeft = table.scrollLeft;
            isDragging = false;
            shouldCancelClick = false;
        });

        table.addEventListener('pointermove', (event) => {
            if (activePointerId !== event.pointerId) {
                return;
            }

            const deltaX = event.clientX - startX;
            const deltaY = event.clientY - startY;

            if (!isDragging) {
                if (Math.abs(deltaX) < 8) {
                    return;
                }

                if (Math.abs(deltaY) > Math.abs(deltaX)) {
                    activePointerId = null;
                    return;
                }

                isDragging = true;
                shouldCancelClick = true;
                table.classList.add('is-dragging');

                if (table.setPointerCapture) {
                    table.setPointerCapture(event.pointerId);
                }
            }

            event.preventDefault();
            table.scrollLeft = startScrollLeft - deltaX;
        });

        table.addEventListener('pointerup', () => {
            resetDrag();
        });

        table.addEventListener('pointercancel', () => {
            resetDrag();
        });

        table.addEventListener('lostpointercapture', () => {
            resetDrag();
        });

        table.addEventListener('click', (event) => {
            if (!shouldCancelClick) {
                return;
            }

            event.preventDefault();
            event.stopPropagation();
            shouldCancelClick = false;
        }, true);
    });

    syncScrollableState();
    window.addEventListener('resize', syncScrollableState);
});